import moment from 'moment';
import localization from 'moment/locale/it';

/**
 * sets moment to italian
 */
moment.updateLocale('it', localization);

export default moment;